var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 18.6666H13.9999C17.3333 18.6666 18.6666 17.3333 18.6666 13.9999V9.99992C18.6666 6.66659 17.3333 5.33325 13.9999 5.33325H9.99992C6.66659 5.33325 5.33325 6.66659 5.33325 9.99992V13.9999C5.33325 17.3333 6.66659 18.6666 9.99992 18.6666Z",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 10.6667C10.7365 10.6667 11.3334 10.0697 11.3334 9.33333C11.3334 8.59695 10.7365 8 10.0001 8C9.2637 8 8.66675 8.59695 8.66675 9.33333C8.66675 10.0697 9.2637 10.6667 10.0001 10.6667Z",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78003 16.6333L9.0667 14.4266C9.59336 14.0733 10.3534 14.1133 10.8267 14.52L11.0467 14.7133C11.5667 15.16 12.4067 15.16 12.9267 14.7133L15.7 12.3333C16.22 11.8866 17.06 11.8866 17.58 12.3333L18.6667 13.2666",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.1aa4a25e66a7e2a9093604533a09bc64.svg";
export { ForwardRef as ReactComponent };